export const BILLING_OVERVIEW_KEY = ['billing', 'overview'] as const
export const PAYMENT_METHOD_KEY = ['billing', 'payment-method'] as const
